import {PageHeader} from "@ant-design/pro-layout";
import {navigateBackHandler} from "../../helpers/mainHelpers";
import React, {useMemo} from "react";
import {Query} from "appwrite";
import {Link} from "react-router-dom";
import {InfoCircleOutlined} from "@ant-design/icons";
import {SURGERY_SCHEDULE} from "../../enums/routes";
import {useAuth} from "../../context/authContext";
import AddActionButton from "../../components/action-buttons/addAction-button/AddActionButton";
import SurgeryRequestsTable from "./components/surgeryRequests-table/SurgeryRequestsTable";
import {useSurgeryRequestsController} from "../../controllers/surgeryRequests-controller";
import UpsertSurgeryRequestsModal from "../../components/modals/upsertSurgeryRequests-modal/UpsertSurgeryRequestsModal";
import SurgeryRequestDetailsModal from "../../components/modals/surgeryRequestDetails-modal/SurgeryRequestDetailsModal";
import ScrollToTopButton from "../../components/main-buttons/scroll-button/ScrollToTopButton";
import "./style.less";


const SurgeryRequestsPage = () => {
  const {currentUser, isAdmin} = useAuth()
  const userId = currentUser?.id
  const queries = useMemo(
    () => userId && !isAdmin ? [Query.equal('createdById', userId)] : [],
    [userId, isAdmin],
  )
  const surgeryRequestsController = useSurgeryRequestsController({queries, enabled: !!userId})
  return (
    <>
      <div className="page_title">
        <PageHeader
          title={
            <div className="page-header_title">
              <div className="page_name">{isAdmin ? "Усі заявки на операції" : "Мої заявки на операції"}</div>
            </div>
          }
          extra={<AddActionButton className="surgery-requests-book-button" size="large" onClick={surgeryRequestsController.toggleModal} shape='default'>Створити заявку</AddActionButton>}
          onBack={navigateBackHandler}
        />
      </div>
      <div className='page_content surgery-requests-page'>
        <div className="surgery-requests-hint">
          <InfoCircleOutlined aria-hidden="true"/>
          <p>{isAdmin
            ? "Тут відображаються заявки всіх користувачів. Переглянути операції за датою та операційною можна в розділі "
            : "Тут відображаються лише заявки, створені вами. Операції всіх користувачів можна переглянути в розділі "}
            <Link to={`/${SURGERY_SCHEDULE}`}>«Розклад операцій»</Link>.
          </p>
        </div>
        <SurgeryRequestsTable surgeryRequestsController={surgeryRequestsController}/>
        <ScrollToTopButton elementSelector={".page_content"}/>
      </div>
      {surgeryRequestsController.isModalOpen && <UpsertSurgeryRequestsModal controller={surgeryRequestsController}/>}
      {surgeryRequestsController.isDetailsModalOpen &&
          <SurgeryRequestDetailsModal controller={surgeryRequestsController}/>}
    </>
  )
}

export default SurgeryRequestsPage
